import { useSnackbar } from 'notistack'
import { useTheme } from '@mui/material/styles'

export function customSnackbar() {
  const { enqueueSnackbar } = useSnackbar()
  const theme = useTheme()

  const showSuccessSnackbar = (message) => {
    enqueueSnackbar(message, {
      variant: 'success',
      style: { backgroundColor: theme.custom.snackbar.success },
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'right',
      },
    })
  }

  const showErrorSnackbar = (message) => {
    enqueueSnackbar(message, {
      variant: 'error',
      style: { backgroundColor: theme.custom.snackbar.error },
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'right',
      },
    })
  }

  const showWarningSnackbar = (message) => {
    enqueueSnackbar(message, {
      variant: 'warning',
      style: { backgroundColor: theme.custom.snackbar.warning },
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'right',
      },
    })
  }

  return { showErrorSnackbar, showWarningSnackbar, showSuccessSnackbar }
}
